import React, { useState, useEffect } from 'react';
import {Modal, Button, Spinner, Alert, Form} from 'react-bootstrap';
import { apiService } from '../services/apiService';
import _ from 'lodash';
import {useEnvironment} from "../contexts/EnvironmentContext.jsx";
import { eventBus, EVENTS } from '../utils/events';
import {useAuth} from "@/contexts/AuthContext.jsx";

const FileUploadModal = ({ responseArr, show, onHide, user, onApprovalComplete}) => {
    const {
        environment,        // 'development' or 'production'
        isDevelopment,      // boolean flag
        isProduction,       // boolean flag
        apiEndpoints,       // object with API endpoints
        changeEnvironment   // function to change environment
    } = useEnvironment();
    const { getCategories } = useAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [response, setResponse] = useState({});
    const [showAddToMemories, setShowAddToMemories] = useState(false);
    const [showCreateSaveResponse, setShowCreateSaveResponse] = useState(true);
    const [displayData, setDisplayData] = useState(responseArr);
    const [editableData, setEditableData] = useState('');

    useEffect(() => {
        setEditableData(JSON.stringify(displayData, null, 2));
    }, [displayData]);

    useEffect(() => {
        console.log('[useEffect]---responseArr-->',responseArr);
        let newResponse = {};
        if (_.get(responseArr, 0)) {
            newResponse = _.get(responseArr, 0);
        } else {
            newResponse = _.get(responseArr, 'response[0]');
        }
        setResponse(newResponse);
        setDisplayData(responseArr);
    }, [responseArr]);

    useEffect(() => {
        if (show) {
            setError('');
            setLoading(false); // Optional: also reset loading state
            // You could also reset other states here if needed
        }
    }, [show]);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    const handleCreateSaveResponse = async () => {
        const responseFormData = {
            uid: user.id,
            submission_id: responseArr.submission[0].submission_id,
            submissionApprove: true,
            group_id: user.groupId,
            events: responseArr.events.map(event => ({
                event_id: event.event_id,
                event_name: event.event_name,
                start_date: event.start_date,
                end_date: event.end_date,
                start_time: event.start_time,
                end_time: event.end_time,
                recurrence: event.recurrence,
                location: event.location,
                description: event.description,
                category: event.category,
                people: event.people
            })),
            tasks: responseArr.tasks.map(task => ({
                task_id: task.task_id,
                category: task.category,
                title: task.title,
                description: task.description,
                priority: task.priority,
                due_date: task.due_date,
                status: task.status,
                assigned_to: task.assigned_to,
                tags: task.tags,
                estimated_time: task.estimated_time,
                dependencies: task.dependencies
            }))
        };
        setShowCreateSaveResponse(false);
        setShowAddToMemories(true);
        setDisplayData(responseFormData);
    }

    const handleAddToMemories = async () => {
        const formData = displayData;

        console.log('---formData-->',editableData);
        setLoading(true);
        setError('');
        try{
            const responseApprove = await apiService.approveUpload(apiEndpoints.approve, editableData);
            console.log('[handleAddToMemories]----->',responseApprove[0]);
            setLoading(false);
            if (onApprovalComplete) {
                responseApprove.response[0].status = 'approved';
                onApprovalComplete(responseApprove.response[0]);
            }

            // Emit event to refresh feeds
            eventBus.emit(EVENTS.MEMORY_APPROVED, {
                submissionId: responseApprove.response[0].submission_id,
                response: responseApprove.response[0]
            });
            setError('');
            onHide();
        }catch(error){
            setError('Server error');
            console.error(error);
        }finally {
            setShowCreateSaveResponse(true);
            setShowAddToMemories(false);
            setLoading(false);
        }
    };

    const handleDiscard = async () => {
        const formData = {
            uid: user.id,
            submission_id: responseArr.submission[0].submission_id,
            submissionApprove: 'FALSE',
            createFeeds: 'FALSE'
        }
        setLoading(true);
        try{
            const responseApprove = await apiService.approveUpload(apiEndpoints.approve, formData);
            setLoading(false);
            if (onApprovalComplete) {
                responseApprove.status = 'cancelled';
                onApprovalComplete(responseApprove);
            }

            // Emit event for discard as well if needed
            eventBus.emit(EVENTS.MEMORY_DISCARDED, {
                submissionId: responseApprove.submission_id
            });

            setError('');
            onHide();
        }catch(error){
            console.log('error----->',error);
            setError('Server error');
        }finally {
            setShowCreateSaveResponse(true);
            setShowAddToMemories(false);
            setLoading(false);
        }
    };

    const getModalTitle = () => {
        if (response && response.summary) {
            return 'Confirm memory - '
        }
        return 'Confirm memory';
    };

    const getModalTitleSummary = () => {
        if (response && response.summary) {
            return response.summary;
        }
        return '';
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="memory-modal"
            centered
            className={'confirm-modal'}
        >
            <Modal.Header >
                <Modal.Title id="memory-modal" className="w-100">
                    <div className="d-flex align-items-center">
                        <div>
                            Build: {environment}
                            {loading ? 'Processing...' : getModalTitle() }<span className={'response-summary'}>{getModalTitleSummary()}</span>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : responseArr ? (
                    <>
                        {error && <Alert variant="danger">{error}</Alert>}

                        <div className="mb-4">
                            <Form.Label className="text-uppercase fw-bold text-muted small mb-2">
                                RESPONSE DATA
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={15}
                                value={editableData}
                                onChange={(e) => setEditableData(e.target.value)}
                                style={{
                                    fontFamily: 'monospace',
                                    fontSize: '13px',
                                    backgroundColor: '#f8f9fa',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '8px',
                                    padding: '12px'
                                }}
                            />
                        </div>
                    </>
                ) : (
                    <Alert variant="danger">
                        Submission not provided.
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer className="px-4 py-3 border-0">
                <div className="d-flex gap-2 ms-auto">
                    <Button
                        variant="outline-secondary"
                        onClick={handleDiscard}
                        style={{
                            borderRadius: '20px',
                            paddingLeft: '20px',
                            paddingRight: '20px'
                        }}
                    >
                        Discard
                    </Button>
                    {showAddToMemories && (
                        <Button
                            onClick={handleAddToMemories}
                            style={{
                                backgroundColor: '#4285f4',
                                border: 'none',
                                borderRadius: '20px',
                                paddingLeft: '20px',
                                paddingRight: '20px'
                            }}
                        >
                            Add to memories
                        </Button>
                    )}

                    {showCreateSaveResponse && (
                        <Button
                            onClick={handleCreateSaveResponse}
                            style={{
                                backgroundColor: '#4285f4',
                                border: 'none',
                                borderRadius: '20px',
                                paddingLeft: '20px',
                                paddingRight: '20px'
                            }}
                        >
                            Create Save Response
                        </Button>
                    )}
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default FileUploadModal;